import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from '../services/data.service';
import { MemberRoles } from '../models/member.model';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private dataService: DataService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.dataService.selectedMemberInfo$.pipe(
      map((memberInfo) => {
        const isTiesFocalPoint = memberInfo.roles.includes(MemberRoles.TiesFocalPoint);
        const isSGContact = memberInfo.roles.includes(MemberRoles.SGContact);

        if (!isTiesFocalPoint && !isSGContact) {
          return this.router.parseUrl('/settings');
        }
        return true;
      })
    );
  }
}
